<template>
  <section class="create-report">
    <header>
      <h1>New Report</h1>
    </header>
    <p-create-report @submit="create" />
    <footer></footer>
  </section>
</template>

<script>
import CreateOrEditReport from './_CreateOrEdit.vue';

export default {
  components: {
    'p-create-report': CreateOrEditReport
  },
  methods: {
    async create(data) {
      try {
        const { fields, ...payload } = data;
        await this.$store.dispatch('reports/create', payload);

        this.$toast.success({
          title: 'Create completed',
          message: `Report was created.`
        });
        this.$router.push({ path: `/reports/` });
      } catch (e) {
        const { message } = JSON.parse(await e.response.text());
        this.$toast.error({
          title: 'Create failed',
          message: message || `Please, try again later or contact our development team.`
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.create-report {
  display: grid;
  grid-gap: 0.5rem;
  grid-template-rows: minmax(0, max-content) minmax(0, 1fr);
  width: 100%;
  height: 100%;
  padding: 0 0.5rem 0 1rem;

  header {
    width: 100%;
    padding: 0.5rem 0.5rem 0 0;
    box-sizing: border-box;
  }

  h1 {
    color: var(--theme-on-surface);
    font-size: 1.5rem;
    font-weight: 700;
  }
}
</style>
